<template>
  <div v-if="show" class="loader-wrapper w-full h-full">
    <div class="flex h-full items-center justify-center flex-col">
      <div class="text-gray-400 text-sm pb-4">{{ $t('no_data') }}. {{ $t('unexpected') }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NoData',
  props: {
    show: {
      type: Boolean,
      default: true,
      require: true,
    }
  },
}
</script>

<style lang="sass">
.loader-wrapper > div
  min-height: 150px
</style>